module.exports = __webpack_public_path__ + "media/images/mamari/wowma/btn-download-7309b7ffc8133626700331a42dca1a67.png";